import { render } from "./affiliatePartnerCalculator.vue?vue&type=template&id=0b16f343&scoped=true&ts=true"
import script from "./affiliatePartnerCalculator.vue?vue&type=script&lang=ts"
export * from "./affiliatePartnerCalculator.vue?vue&type=script&lang=ts"

import "./affiliatePartnerCalculator.vue?vue&type=style&index=0&id=0b16f343&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b16f343"]])

export default __exports__